var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"holiday-deal-badge"},[_vm._v("Holiday Deal")])
}
var staticRenderFns = []

export { render, staticRenderFns }